import { type ReactNode } from 'react';
import { COUNTRIES } from '@/utils/countries';
import { FieldInput, FieldSelect } from '@/components/ui/field-input';
import { fieldChange } from '../utils/field-change';
import type {
  NewMemberData,
  NewMemberFieldErrors,
} from '../hooks/use-new-member-form';

export type RowProps = {
  data: NewMemberData;
  onChange: (d: NewMemberData) => void;
  errors: NewMemberFieldErrors;
};

export function NameRow({ data, onChange, errors }: RowProps): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-sm sm:grid-cols-2">
      <FieldInput
        placeholder="Nombre"
        value={data.first_name}
        onChange={fieldChange(data, onChange, 'first_name')}
        error={errors.first_name}
      />
      <FieldInput
        placeholder="Apellidos"
        value={data.last_name}
        onChange={fieldChange(data, onChange, 'last_name')}
        error={errors.last_name}
      />
    </div>
  );
}

export { ContactRow } from './new-member-contact-row';

export function PhoneRow({ data, onChange, errors }: RowProps): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-sm sm:grid-cols-[120px_1fr]">
      <FieldSelect
        value={data.phone_prefix}
        onChange={fieldChange(data, onChange, 'phone_prefix')}
        error={errors.phone_prefix}
      >
        <option value="">Prefijo</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.dialCode}>
            {c.dialCode} ({c.code})
          </option>
        ))}
      </FieldSelect>
      <FieldInput
        type="tel"
        placeholder="Número de teléfono"
        value={data.phone_number}
        onChange={fieldChange(data, onChange, 'phone_number')}
        error={errors.phone_number}
      />
    </div>
  );
}

export function LocationRow({ data, onChange, errors }: RowProps): ReactNode {
  return (
    <>
      <FieldSelect
        value={data.country}
        onChange={fieldChange(data, onChange, 'country')}
        error={errors.country}
      >
        <option value="">Seleccionar país</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </FieldSelect>
      <FieldInput
        placeholder="Ciudad"
        value={data.city}
        onChange={fieldChange(data, onChange, 'city')}
        error={errors.city}
      />
    </>
  );
}
